import { render, staticRenderFns } from "./ChartBarVertical.vue?vue&type=template&id=704c2da4&"
import script from "./ChartBarVertical.vue?vue&type=script&lang=js&"
export * from "./ChartBarVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports